import { routeTree } from "@client/routeTree.gen";
import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: "intent",
    scrollRestoration: true,
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}
